define.alias("shared/components/shared/bttp/bttp-suggestions", "media/components/shared/bttp/bttp-suggestions");